import React from 'react';
import { FolderOpen, UserCircle, Settings2, Globe } from 'lucide-react';

const Sidebar = () => {
  return (
    <div className="text-white p-4 flex flex-col border-r border-zinc-800" style={{backgroundColor: '#141414', width: '296px'}}>
      <div className="mb-8">
        <h1 className="text-2xl font-bold">Fnction</h1>
      </div>
      <nav className="flex-grow">
        <ul>
          <li className="mb-2">
            <a href="#" className="flex items-center p-3 rounded-lg relative group hover:bg-gray-700/20 transition-colors">
              <div className="absolute left-0 top-0 bottom-0 w-1 bg-blue-500 rounded-r-full opacity-0 group-hover:opacity-100 transition-opacity" style={{backgroundColor: '#0569ff'}}></div>
              <Globe className="w-5 h-5 mr-4 ml-2" />
              Home
            </a>
          </li>
          <li className="mb-2">
            <a href="#" className="flex items-center p-3 rounded-lg relative group hover:bg-gray-700/20 transition-colors">
              <div className="absolute left-0 top-0 bottom-0 w-1 bg-blue-500 rounded-r-full opacity-0 group-hover:opacity-100 transition-opacity" style={{backgroundColor: '#0569ff'}}></div>
              <FolderOpen className="w-5 h-5 mr-4 ml-2" />
              My files
            </a>
          </li>
          <li className="mb-2">
            <a href="#" className="flex items-center p-3 rounded-lg relative group hover:bg-gray-700/20 transition-colors">
              <div className="absolute left-0 top-0 bottom-0 w-1 bg-blue-500 rounded-r-full opacity-0 group-hover:opacity-100 transition-opacity" style={{backgroundColor: '#0569ff'}}></div>
              <UserCircle className="w-5 h-5 mr-4 ml-2" />
              Account
            </a>
          </li>
        </ul>
      </nav>
      <div>
        <a href="#" className="flex items-center p-3 rounded-lg relative group hover:bg-gray-700/20 transition-colors">
          <div className="absolute left-0 top-0 bottom-0 w-1 bg-blue-500 rounded-r-full opacity-0 group-hover:opacity-100 transition-opacity" style={{backgroundColor: '#0569ff'}}></div>
          <Settings2 className="w-5 h-5 mr-4 ml-2" />
          Settings
        </a>
      </div>
    </div>
  );
};

export default Sidebar; 